exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.target-pane_target-pane_1M1uZ {\n    /* Makes columns for the sprite library selector + and the stage selector */\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    /*min-height: 1000px;*/\n}\n\n.target-pane_stage-selector-wrapper_2fZXk {\n    display: flex;\n    flex-basis: 72px;\n    flex-shrink: 0;\n}\n\n[dir=\"ltr\"] .target-pane_stage-selector-wrapper_2fZXk {\n    margin-left: calc(0.5rem / 2);\n}\n\n[dir=\"rtl\"] .target-pane_stage-selector-wrapper_2fZXk {\n    margin-right: calc(0.5rem / 2);\n}\n", ""]);

// exports
exports.locals = {
	"target-pane": "target-pane_target-pane_1M1uZ",
	"targetPane": "target-pane_target-pane_1M1uZ",
	"stage-selector-wrapper": "target-pane_stage-selector-wrapper_2fZXk",
	"stageSelectorWrapper": "target-pane_stage-selector-wrapper_2fZXk"
};